import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCarrierScoring from './ReportCarrierScoring'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCarrierScoring} />
    </Switch>
)

export default Components
